export const ky = {
    LEFT: 'Влево: өтүү мурунку жылга карата чыгарылды.',
    RIGHT: 'Оңго: өтүү кийинки болуп өттү.',
    DOWN: 'Төмөн: өтүүгө төмөнкү сапта.',
    UP: 'Жогору: өтүүгө мурунку сапта.',
    PGUP: 'Жогору: которуштуруу мурунку жылга карата айына.',
    PGDOWN: 'PgDown: өтүүгө кийинки ай.',
    HOME: 'Үйлөр: өтүү, өткөн жылга карата.',
    END: 'Акырына: которулсун кийинки жылга.',
    ESC: 'Эку/бүгүн/жаба: жаба календары. Нускаманы',
    TITLE: 'Клавиатура '
};
